<template>
  <b-modal
    :title="this.isEdit ? 'Sửa thông tin ứng dụng' : 'Thêm mới ứng dụng'"
    @hidden="hideModal"
    centered
    no-close-on-backdrop
    ref="modalCapNhatApp"
    size="xl"
  >
    <validation-observer ref="observerapp">
      <b-form class="font-size-14">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <validation-provider
              rules="required|maxlength:100"
              name="Tên ứng dụng"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4"
                id="app-input-name-group"
                label="Tên ứng dụng"
                label-class="required font-weight-bold"
                label-for="app-input-name"
              >
                <b-form-input
                  :state="getValidationState(validationContext)"
                  aria-describedby="app-live-feedback"
                  class="border-radius-4"
                  id="app-input-name"
                  name="app-input-name"
                  v-model="form.name"
                ></b-form-input>
                <b-form-invalid-feedback id="app-live-feedback"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-md-6 col-xs-12">
            <validation-provider
              name="Mã ứng dụng"
              rules="required|maxlength:100|code|hashcode"
              v-slot="validationContext"
            >
              <b-form-group
                class="mb-4"
                id="app-input-code-group"
                label="Mã ứng dụng"
                label-class="required font-weight-bold"
                label-for="app-input-code"
              >
                <b-form-input
                  :state="getValidationState(validationContext)"
                  aria-describedby="app-live-feedback"
                  class="border-radius-4"
                  id="app-input-code"
                  name="app-input-code"
                  v-model="form.code"
                ></b-form-input>
                <b-form-invalid-feedback id="app-live-feedback"
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
        </div>

        <b-form-group
          class="mb-4"
          id="app-input-description-group"
          label="Mô tả"
          label-for="app-input-description"
          label-class="font-weight-bold"
        >
          <b-form-textarea
            aria-describedby="app-live-feedback"
            class="border-radius-4"
            id="app-input-description"
            name="app-input-description"
            rows="2"
            max-rows="100"
            v-model="form.description"
          ></b-form-textarea>
        </b-form-group>
        <validation-provider
          rules="required|maxlength:255"
          name="URL"
          v-slot="validationContext"
        >
          <b-form-group
            class="mb-4 required"
            id="app-input-url-group"
            label="URL"
            label-for="app-input-url"
            label-class="font-weight-bold"
          >
            <b-form-input
              aria-describedby="app-live-feedback"
              :state="getValidationState(validationContext)"
              class="border-radius-4"
              id="app-input-url"
              name="app-input-url"
              v-model="form.url"
            ></b-form-input>
            <b-form-invalid-feedback id="app-live-feedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
    <template v-slot:modal-footer>
      <div class="d-flex">
        <base-button
          @click="onSubmit()"
          button="Lưu"
          class="btn btn-main ml-2"
          :disabled="isLoading"
        />
        <base-button button="Đóng" @click="hideModal()" class="btn btn-line">
          {{ BO_QUA_BUTTON_LABEL }}
        </base-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";

import {
  CAP_NHAT_APP_THANH_CONG,
  THEM_MOI_APP_THANH_CONG,
} from "@/constants/message";

export default {
  name: "modalCapNhatApp",
  props: {
    data: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      isLoading: false,
      form: {
        name: "",
        code: "",
        isActive: true,
        url: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/danhSachApp",
    }),
  },
  watch: {
    data: function () {
      if (this.isEdit) {
        this.form = Object.assign(this.form, this.data);
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    hideModal() {
      this.$refs["modalCapNhatApp"].hide();
    },
    onSuccess() {
      this.$emit("refresh");
      this.hideModal();
    },
    resetForm() {
      this.form = {
        name: "",
        code: "",
        isActive: true,
        url: "",
        description: "",
      };
    },
    async onSubmit() {
      const isValid = await this.$refs.observerapp.validate();
      const $vm = this;
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          this.$store
            .dispatch("app/capNhatApp", {
              data: $vm.form,
              onSuccess: this.onSuccess,
            })
            .then(() => {
              this.$toasted.clear();
              this.$toasted.global.showSuccessMessage({
                message: CAP_NHAT_APP_THANH_CONG,
              });
              this.isLoading = false;
              this.onSuccess();
            })
            .catch((err) => {
              this.isLoading = false;
              this.$toasted.clear();
              this.$toasted.global.showErrorMessage({
                message: err.data.message,
              });
            });
        } else {
          this.$store
            .dispatch("app/themMoiApp", {
              data: $vm.form,
            })
            .then(() => {
              this.$toasted.clear();
              this.$toasted.global.showSuccessMessage({
                message: THEM_MOI_APP_THANH_CONG,
              });
              this.isLoading = false;
              this.onSuccess();
            })
            .catch((err) => {
              this.isLoading = false;
              console.log(err);
              this.$toasted.clear();
              this.$toasted.global.showErrorMessage({
                message: err.data.message,
              });
            });
        }
      }
    },
  },
};
</script>
